import layoutPage from './layoutPage';

export default layoutPage;
